export default __webpack_public_path__ + "static/media/764.8017c2b9.png";